import { connectFunctionsEmulator, getFunctions, type Functions } from 'firebase/functions';
import { getApp } from './app';
import { EMULATOR_HOST, EMULATOR_PORTS, emulatorsEnabled } from './emulator';

/**
 * Instance `Functions` PARTAGÉE (europe-west1 — sinon le SDK vise us-central1 et
 * tout échoue en NOT_FOUND). Câble l'émulateur UNE fois si activé, pour que
 * TOUS les callables (datasets, accès, prix, commande) y passent en test.
 */

const REGION = 'europe-west1';
let cached: Functions | null = null;

export function getFns(): Functions | null {
  const app = getApp();
  if (app === null) return null;
  if (cached !== null) return cached;
  cached = getFunctions(app, REGION);
  if (emulatorsEnabled()) {
    connectFunctionsEmulator(cached, EMULATOR_HOST, EMULATOR_PORTS.functions);
  }
  return cached;
}
